import { render } from "./HomeTasksPage.vue?vue&type=template&id=515a3e19&ts=true"
import script from "./HomeTasksPage.vue?vue&type=script&lang=ts"
export * from "./HomeTasksPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__